import { FC, useEffect, useState } from "react";
import ImagePreviewModal from "./image-preview-modal";
import ic_image_default from "../../assets/icons/ic_image_default.svg";
import ic_user_default from "../../assets/icons/ic_user_default.svg";
import CookieUtils from "../../utils/cookie-utils";
import ic_notify_default from "../../assets/images/notify-img-default.png"


interface ImageProps {
  url?: string;
  className?: string;
  onClick?: () => void;
  fallBackUrl?: string;
  style?: React.CSSProperties;
  isLocal?: boolean;
  isUser?: boolean;
  isReview?: boolean;
  isNotify?: boolean;
}

const ImageCustom: FC<ImageProps> = ({
  url,
  className,
  onClick,
  fallBackUrl,
  style,
  isLocal = true,
  isUser = true,
  isReview = false,
    isNotify = false,

}: ImageProps) => {
  const [imageSrc, setImageSrc] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const imageDefault = isUser ? ic_user_default : isNotify ? ic_notify_default : ic_image_default;

  useEffect(() => {
    const resolvedUrl = url ?? imageDefault;
    let mediaURL = CookieUtils.getCookie("CONFIG_RESOURCE_URL");

    setImageSrc(
      isLocal
        ? resolvedUrl
        : resolvedUrl.startsWith("http")
        ? resolvedUrl
        : `${mediaURL}/${resolvedUrl}`
    );
  }, [url, isLocal, imageDefault]);

  const handleError = (
    event: React.SyntheticEvent<HTMLImageElement, Event>
  ) => {
    event.currentTarget.onerror = null; // prevents looping if image onError also fails
    event.currentTarget.src = fallBackUrl ?? imageDefault;
  };

  const handleClick = () => {
    if (isReview) {
      setIsModalOpen(true);
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <>
      {onClick || isReview ? (
        <button
          className="w-full h-full p-0 border-none"
          onClick={handleClick}
          style={style}
        >
          <img
            className={className}
            src={imageSrc}
            onError={handleError}
            alt={imageSrc}
          />
        </button>
      ) : (
        <img
          className={className}
          src={imageSrc}
          onError={handleError}
          style={style}
          alt={imageSrc}
        />
      )}

      {isReview && (
        <ImagePreviewModal
          opened={isModalOpen}
          src={imageSrc}
          fallbackSrc={fallBackUrl ?? imageDefault}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default ImageCustom;
